export default {
  plans: [],
  selectedPeriod: null,
  selectedPlan: {},
  selectedPaymentMethod: null,
  selectedLocationsCount: 0,
  pricePreview: "0",
  initialChosenPlan: null,
  taxPrice: 0,
  promotionCodes: null,
  promoCode: "",
  limitsUsage: null,
  currency: null,
  initialPlanIndex: null,
  planChangeType: "no_change"
};
